import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { XdViewerComponent } from './xd-viewer.component';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '../../../core/modules/shared.module';
import { SelectorModule } from '../selector/selector.module';

const routes: Routes = [
    {
        path     : '3d-viewer',
        component: XdViewerComponent,
        /* resolve  : {
            data: DashboardService
        } */
    },
    /* {
        path     : 'dashboard/:activoSeleccionado',
        component: FuseDashboardComponent,
        resolve  : {
            data: DashboardService
        }
    } */
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
    SelectorModule
  ],
  declarations: [XdViewerComponent]
})
export class XdViewerModule { }



// WEBPACK FOOTER //
// ./src/app/main/content/xd-viewer/xd-viewer.module.ts